// Cấu hình cây phân cấp + wizard khai báo theo từng org_type (xem OrgType2Association trong
// consts/AssociationStatus.js). Mỗi loại tổ chức liên kết tới 1 loại thực thể khác nhau (Giáo xứ /
// Giáo phận-Tổng Giáo phận / Dòng tu-Tu hội), mỗi loại có field tổ tiên khác nhau sẵn có trên object
// `association` trả về từ API (ParishTransformerBasic/Tiny, DioceseTransformerBasic/Tiny,
// ReligiousOrderTransformerBasic/Tiny) - không cần gọi thêm API nào khác để dựng cây.

// Nodes "tổ tiên" (các cấp NẰM TRÊN tổ chức của bạn trong cây) - MỖI cấp mang theo `ownerOrg` riêng
// (object Organization đã xác thực chính thức đại diện quản lý cấp đó, hoặc null - xem
// DeaneryTransformerTiny/DioceseTransformerBasic|Tiny/ReligiousOrderTransformerTiny::transform()).
// `ownerOrg` quyết định 2 việc cùng lúc: (1) "đã kết nối" (xanh, có `ownerOrg`) hay "chưa có tổ chức
// quản lý" (xám, `ownerOrg=null`) - KHÔNG PHẢI cứ có tên trong danh bạ là "đã kết nối"; (2) bấm vào
// node đi tới đâu (`getLinkToDetail(ownerOrg)`, xem AssociationHierarchyTree.js) - node không có
// ownerOrg thì không bấm được, vì chưa có trang tổ chức nào để đi tới.
export const getAssociationAncestorNodes = (associationTypeValue, association) => {
    if (!association) return []
    switch (associationTypeValue) {
        case 'parish':
            return [
                {
                    key: 'archdiocese',
                    label: 'archdiocese',
                    name: association.archdiocese_fullname || association?.archdiocese?.fullname,
                    ownerOrg: association?.archdiocese?.owner || null,
                },
                {
                    key: 'diocese',
                    label: 'diocese',
                    name: association.diocese_fullname || association?.diocese?.fullname,
                    ownerOrg: association?.diocese?.owner || null,
                },
                {
                    key: 'deanery',
                    label: 'deanery',
                    name: association.deanery_fullname || association?.deanery?.fullname,
                    ownerOrg: association?.deanery?.owner || null,
                },
            ].filter((node) => !!node.name)
        case 'deanery':
            // Giáo hạt: tổ tiên gồm Giáo phận trực tiếp + Tổng giáo phận (nếu diocese_typecd là
            // DIOCESE thường, có archdiocese riêng) - đúng 1 cấp thiếu so với parish (không có
            // deanery ở đây vì chính association NÀY đã là deanery).
            return [
                {
                    key: 'archdiocese',
                    label: 'archdiocese',
                    name: association.archdiocese_fullname || association?.archdiocese?.fullname,
                    ownerOrg: association?.archdiocese?.owner || null,
                },
                {
                    key: 'diocese',
                    label: 'diocese',
                    name: association.diocese_fullname || association?.diocese?.fullname,
                    ownerOrg: association?.diocese?.owner || null,
                },
            ].filter((node) => !!node.name)
        case 'diocese':
            // archdiocese_fullname: field phẳng chỉ có ở DioceseTransformerTiny (đang chờ duyệt) -
            // DioceseTransformerBasic (đã duyệt) chỉ lồng object `archdiocese.fullname`, đọc cả 2
            // dạng để không phụ thuộc trạng thái duyệt.
            return [
                {
                    key: 'archdiocese',
                    label: 'archdiocese',
                    name: association.archdiocese_fullname || association?.archdiocese?.fullname,
                    ownerOrg: association?.archdiocese?.owner || null,
                },
            ].filter((node) => !!node.name)
        case 'religious_order':
            return [
                {
                    key: 'parent',
                    label: 'parent religious order',
                    name: association?.parent?.fullname || association?.parent?.name,
                    ownerOrg: association?.parent?.owner || null,
                },
            ].filter((node) => !!node.name)
        default:
            return []
    }
}

// Node cuối cùng (chính tổ chức đang khai báo) - label hiển thị trên "Cấp N" cuối của cây.
export const getAssociationFinalNodeLabel = (associationTypeValue) => {
    switch (associationTypeValue) {
        case 'parish':
            return 'parish'
        case 'deanery':
            return 'deanery'
        case 'diocese':
            return 'diocese or archdiocese'
        case 'religious_order':
            return 'religious order'
        default:
            return 'organization'
    }
}

// Danh sách quyền lợi hiển thị ở khối "Quyền lợi khi hoàn tất liên kết cây hệ thống" - copy riêng
// theo từng loại, giữ lại đúng nội dung quyền lợi đã có từ flow cũ cho Giáo xứ (family book + giờ lễ),
// viết thêm bản tương ứng cho Giáo phận/Dòng tu theo cùng tinh thần.
export const getAssociationBenefits = (associationTypeValue) => {
    switch (associationTypeValue) {
        case 'parish':
            return [
                'benefit_catholic_family_register',
                'benefit_mass_schedule_sync',
                'benefit_verified_badge',
            ]
        case 'deanery':
            return [
                'benefit_deanery_parish_management',
                'benefit_deanery_data_sync',
                'benefit_verified_badge',
            ]
        case 'diocese':
            return [
                'benefit_diocese_structure_management',
                'benefit_diocese_data_sync',
                'benefit_verified_badge',
            ]
        case 'religious_order':
            return [
                'benefit_religious_order_member_management',
                'benefit_religious_order_data_sync',
                'benefit_verified_badge',
            ]
        default:
            return ['benefit_verified_badge']
    }
}
